import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService, PopupService, PopupMessageSummaries, PopupMessageTypes } from '../shared/shared.module';
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})

export class AuthComponent implements OnInit {
  private code = '';
  private token = '';

  constructor(
    private accountService: AccountService,
    private popupService: PopupService,
    private router: Router
  ) { }

  ngOnInit() {

    if (window.location.href !== '') {
      let url = window.location.href;

      // От одноклассников приходит в ответе строка с разделителем # вместо ?, здесь происходит замена к нормальному виду
      if (url.indexOf('#') !== -1) {
        url = url.replace('#', '?');
      }

      const queryStr = url.split('?')[1];
      if (!queryStr) {
        return;
      }

      const query = queryStr.split('&');
      const params: any = {};
      query.forEach(function (x) {
        const atoms = x.split('=');
        const name = atoms[0];
        const value = atoms[1];
        params[`${name}`] = value;
      });

      if (query.length !== null) {
        this.code = params['code'];
        this.token = params['access_token'];
        const goTo = params['goto'];

        if (goTo) {
          location.href = decodeURIComponent(goTo);
          return;
        }
        const state = params['state'];

        switch (state) {
          case 'OK':
            this.processSubscription(this.accountService.getOkSession(this.code));
            break;

          case 'GG':
            this.processSubscription(this.accountService.getGoogleSession(this.token));
            break;

          case 'VK':
            this.processSubscription(this.accountService.getVkSession(this.code));
            break;

          case 'FB':
            this.processSubscription(this.accountService.getFbSession(this.code));
            break;

          case 'confirm':
            this.processConfirmation(this.accountService.confirm(params['key']));
            break;

          case 'changeMail':
              this.accountService.getCredentialsPromise(false, true).then(cred => {
              if (!cred) {
                this.openAuthorizationForm(window.location.href.split('/')[3]);
              } else {
                this.accountService.confirmEmailChange(params['key'], cred.Id_Session).then(response => {
                  if (response.Result.ReturnCode > 0) {
                    this.accountService.getCredentialsPromise(true).then(() => {
                      this.router.navigate(['main', 'settings', 'personal']);
                      const severity = PopupMessageTypes.Success;
                      const info = PopupMessageSummaries.Success;
                      this.popupService.showMessage({ severity: severity, summary: info, detail: response.Result.Message });
                    });
                    return;
                  }
                  this.router.navigate(['main', 'settings', 'personal']);
                });
              }
            });
            break;
        }
      }
    }
  }

  processSubscription(userData: Promise<object>) {
    userData.then(completedUser => {
      if (completedUser && completedUser['Id_Session']) {
        // window.location.reload();
        self.close();
      }
    });
  }

  processConfirmation(target: Promise<any>) {
    target.then(x => {
      if (x !== null) {
        this.router.navigate(['']);
      }
    });
  }

  openAuthorizationForm(redirect: string) {
    this.accountService.returnUrl = redirect;
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts